import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';

const CTASection: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative overflow-hidden" id="cta" style={{backgroundColor: '#EDE8E0'}}>
      <div className="absolute inset-0 opacity-20" style={{backgroundImage: 'linear-gradient(to right, #B85C38, #C97050)'}}></div>
      <div className="container py-16 lg:py-24 relative mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-4xl lg:text-6xl font-medium mb-6">
            Ready to get started?
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-8 lg:px-12">
            Tell us what you hope to change and how you’ll know it worked. We’ll respond with a concise plan, an
            accountable team, and clear milestones. From there, we ship, measure, and scale together.
          </p>
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <a
              href="mailto:hello@fluxlabs.mx"
              className="btn bg-custom-indigo-500 text-white hover:bg-custom-indigo-600 px-8 py-4 text-lg transform hover:scale-105"
            >
              Say Hello
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-8 text-sm text-gray-500 dark:text-gray-400"
          >
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;